import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';

export const OrderNotes = ({ notes }) => (notes ? (
    <View style={styles.box}>
      <Text style={styles.rowHeader}>Notes</Text>
      <Text style={styles.normalText}>{notes}</Text>
    </View>
) : null);
